import styled from 'styled-components';
import { PropertyCardActionAreaMixin } from '../../mixins/components/PropertyCardActionAreaMixin';
export var StyledPropertyCardActionArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardActionArea",
  componentId: "c11n-8-111-1__sc-p25vvg-0"
})(["", ""], PropertyCardActionAreaMixin);